/* unplugin-vue-components disabled */import { render } from "./financialDashboard.vue?vue&type=template&id=03620d76&scoped=true"
import script from "./financialDashboard.vue?vue&type=script&lang=js"
export * from "./financialDashboard.vue?vue&type=script&lang=js"

import "./financialDashboard.vue?vue&type=style&index=0&id=03620d76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03620d76"]])

export default __exports__